var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCourierMarker = function SvgCourierMarker(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 57,
    height: 66,
    ref: ref
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "courierMarker_svg__b",
    d: "m28.841 48.617-3.648 3.648a1 1 0 0 1-1.414 0l-3.655-3.655C8.681 46.547 0 36.537 0 24.5 0 10.969 10.969 0 24.5 0S49 10.969 49 24.5c0 12.05-8.699 22.067-20.159 24.117"
  }), /*#__PURE__*/React.createElement("path", {
    id: "courierMarker_svg__c",
    d: "M11.302 15.38c.043.282.073.569.073.863a5.687 5.687 0 1 1-5.695-5.68 5.67 5.67 0 0 1 4.972 2.934c-.794 1.215-1.444 1.94-2.34 1.94H4.875a.813.813 0 0 0 0 1.626h3.438c1.283-.002 2.62-.488 2.989-1.683a5.7 5.7 0 0 0-.644-1.893c.187-.287.38-.594.59-.934 1.21-1.975 2.67-4.353 5.517-5.079l-.495-1.61c-.19-.853-.655-.994-1.645-.989h-.812a.813.813 0 0 1 0-1.625h.811c.73.013 2.727-.004 3.215 2.199l1.594 5.181q.426-.066.872-.068a5.688 5.688 0 1 1-2.424.545l-.637-2.073c-2.27.554-3.458 2.488-4.611 4.369-.422.686-.849 1.38-1.331 1.977Zm6.582-4.267 1.652 5.376a.814.814 0 0 0 1.016.538.81.81 0 0 0 .537-1.016l-1.654-5.374a5.7 5.7 0 0 0-1.551.476m-6.509-6.238H1.12a.813.813 0 0 1 0-1.625h10.256a.813.813 0 0 1 0 1.625m0 3.25H4.37a.813.813 0 0 1 0-1.625h7.006a.813.813 0 0 1 0 1.625"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "courierMarker_svg__a",
    width: "128.6%",
    height: "125.6%",
    x: "-14.3%",
    y: "-9.4%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.407843137 0 0 0 0 0.407843137 0 0 0 0 0.407843137 0 0 0 0.3 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 3.5,
    fill: "#FFF",
    stroke: "#FF8000",
    strokeWidth: 2,
    transform: "translate(24 57)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 2)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#courierMarker_svg__b",
    fill: "#000",
    filter: "url(#courierMarker_svg__a)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#courierMarker_svg__b",
    fill: "#FFF"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#courierMarker_svg__c",
    fill: "#FF8000",
    transform: "translate(16 14)"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCourierMarker);
export default ForwardRef;